import { DropEvent } from "react-dropzone/.";
import JSZip from "jszip";

/**
 * Custom function to handle the file drop event within DropZone
 *
 * This function will check if the file is a zip file and if so, it will extract the files from the zip
 * and return them as an array of files. If the file is not a zip file, it will return the file as is.
 */
export const getFilesFromEvent = async (event: DropEvent): Promise<Array<File | DataTransferItem>> => {
  const files = [];
  const fileList = event.dataTransfer ? event.dataTransfer.files : event.target.files;

  for (let i = 0; i < fileList.length; i++) {
    const file = fileList.item(i);

    if (file.type === "application/zip") {
      const zip = await JSZip.loadAsync(file);
      const zipFiles = await Promise.all(
        Object.keys(zip.files).map(async (filename) => {
          const zipFile = zip.files[filename];
          const blob = await zipFile.async("blob");
          return new File([blob], filename);
        })
      );
      files.push(...zipFiles);
    } else {
      files.push(file);
    }
  }

  return files;
};
